import {
  Box,
  Link,
  Typography,
  Dialog,
  DialogContent,
  Grid,
  DialogTitle,
  IconButton,
  TextareaAutosize,
  Card,
  Select,
  FormControl,
  styled,
  Table,
  TableContainer,
  TableCell,
  tableCellClasses,
  TableRow,
  TableHead,
  TableBody,
} from "@mui/material";
import React, { useEffect, useRef, useState } from 'react';
import styles from './scMembers.module.scss';
import constants from "../../config/constants.json";
import Pagination from '../common/pagination/pagination';
import { CommonButton, CommonOutlinedButton, CustomCheckbox, CustomInputLabel, CustomMenuItem, CustomRequiredInputLabel, CustomSelect, CustomTextFeild } from '../common/StyledComponents/StyledFields';
import CloseIcon from "@mui/icons-material/Close";
import { BeatLoader, BounceLoader, ClipLoader } from 'react-spinners';
import { apiRequest, catchErrorMessageHandler } from "../../infrastructure/backendService";
import ErrorPopup from "../common/ErrorPopup";
import toast, { Toaster } from "react-hot-toast";
import apiPath from "../../config/apiPaths.json";
import ToastComponent from "../common/toastComponent";
import { object, string, ValidationError } from "yup";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CustomizedSwitch from "../common/CustomToggle/CustomToggle";

const StyledTable = styled(Table)(({ theme }) => ({
  borderRadius: "8px",
  borderCollapse: "collapse", // Collapse borders to avoid doubled borders between cells
}));

const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  width: "100%",
  position: "relative",
  overflow: "auto",
  paddingBottom: "4px",
  "&::-webkit-scrollbar": {
    width: "8px",
    height: "8px",
    paddingTop: "10px",
    paddingRight: "10px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#F2BE22", // Scrollbar color
    borderRadius: "8px",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "transparent",
  },
  "&::-webkit-scrollbar-corner": {
    backgroundColor: "transparent",
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: " #FEBE00",
    fontWeight: "700",
    color: "#000",
    textAlign: "left",
    border: "1px solid #fff",
    padding: "10px",
    margin: "10px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    whiteSpace: "nowrap",
    textOrientation: "mixed",
    textAlign: "left",
    margin: 0,
    padding: "10px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: theme.palette.action.hover,
  //   height: "-10px",
  "& td, & th": {
    margin: "10px",
    padding: "10px",
    border: "1px solid #fff",
  },
  "&:nth-of-type(even)": {
    backgroundColor: "#FFECB4", // Set odd rows to white
  },
  "&:nth-of-type(odd)": {
    backgroundColor: " #fff", // Set even rows to yellow
  },
}));
interface ErrorMessageTypes {
  username: string;
  firstName: string;
  lastName: string;
  city: string;
  state: string;
  zipcode: string;
  phonenumber: string;
  email: string;
}

interface UsreErrorMessageTypes {
  signinName: string;
  firstName: string;
  lastName: string;
  city: string;
  state: string;
  phonenumber: string;
  email: string;
  zipcode: string;
}

const AttendedScMeetingComponent = () => {
  const [searchItems, setSearchItem] = useState([]);
  const [searchHeaderItem, setSearchHeaderItem] = useState([]);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [newScmDetails, setNewScmDetails] = useState<any[]>([]);
  const [selectedUsernames, setSelectedUsernames] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [searchButton, setSearchButton] = useState<boolean>(true);
  const [loading, setLoading] = useState(false);
  const [confirmButtonLoading, setConfirmButtonLoading] = useState(false);
  const [MeetingId, setMeetingId] = useState<any[]>([]);
  const [rowData, setRowData] = useState<any>('');
  const [previousYearStatus, setPreviousYearStatus] = useState([]);
  const [currentYearStatus, setCurrentYearStatus] = useState([]);
  const formFields = {
    username: "",
    firstName: "",
    lastName: "",
    city: "",
    state: "",
    zipcode: "",
    phonenumber: "",
    email: "",
  };

  const userFormFields = {
    signinName: "",
    firstName: "",
    lastName: "",
    phonenumber: "",
    email: "",
    city: "",
    state: "",
    zipcode: "",
  };

  const [formData, setFormData] = useState({ ...formFields });
  const [userFormData, setUserFormData] = useState({ ...userFormFields });
  const [errorMessage, setErrorMessage] = useState<ErrorMessageTypes>({ ...formFields });
  const [userErrorMessage, setUserErrorMessage] = useState<UsreErrorMessageTypes>({ ...userFormFields });
  const [userDetails, setUserDetails] = useState<any[]>([]);
  const [scheduleId, setScheduleId] = useState<any[]>([]);
  const [confirmButton, setConfirmButton] = useState<boolean>(true);
  const [confirmedUser, setConfirmedUser] = useState("");
  const [submitButton, setSubmitButton] = useState<boolean>(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const yesNoList = [
    {
      status: "Yes",
    },
    {
      status: "No",
    },
  ]

  const usernameList = [
    {
      username: "username1",
    },
    {
      username: "username2",
    },
  ]
  const [status, setStatus] = useState('')
  const [statuses, setStatuses] = useState<any>({});
  const [scheduleMeetingId, setScheduleMeetingId] = useState<any[]>([]);
  const [pageSize, setPageSize] = useState<number>(20);
  const [showTableComponent, setShowTableComponent] = useState<boolean>(false);
  const [showScmTableComponent, setShowScmTableComponent] = useState<boolean>(false);
  const [isScmView, setIsScmView] = useState<boolean>(false);
  const [openProxyDialog, setOpenProxyDialog] = useState(false);
  const [proxyActive, setProxyActive] = useState(false);
  const [showdevoteeTable, setShowdevoteeTable] = useState<boolean>(false);
  const [searchProxyItems, setSearchProxyItem] = useState([]);
  const [scmMeetingTypeList, setScmMeetingTypeList] = useState([]);
  const [user, setUser] = useState("");
  const [proxyUser, setProxyUser] = useState("");
  const [selectedMeetingId, setSelectedMeetingId] = useState()
  const [meetingData, setMeetingData] = useState({
    meetingName: "",
    meetingId: null,
  });
  const prevPageNumber = usePrevious(pageNumber);


  function usePrevious(value: any) {
    const ref = useRef();

    useEffect(() => {
      ref.current = value;
    }, [value]); // Only re-run if value changes

    return ref.current; // Return previous value (before update)
  }

  useEffect(() => {
    getSelectMeetingListApi();
  }, [])

  useEffect(() => {
    // Check if previous values are not undefined to ensure this is not the first render
    // And then check if the current values differ from the previous ones
    if ((prevPageNumber !== undefined && prevPageNumber !== pageNumber)) {
      searchDataApi();
    }
  }, [pageNumber, prevPageNumber, pageSize]);

  useEffect(() => {
    const defaultStatuses: any = {};
    searchItems.forEach(({ username, quartersAttendance }: any) => {
      defaultStatuses[username] = {};
      quartersAttendance.forEach(({ scheduledMeetingId }: any) => {
        defaultStatuses[username][`${scheduledMeetingId}`] = 'Yes';
      });
    })
    // const defaultStatuses = Array(searchHeaderItem.length).fill('No'); // Assuming default value is 'No'
    setStatuses(defaultStatuses);
  }, [searchItems]);

  const handleToggleChange = (field: string, value: boolean) => {
    setIsScmView(value);
    setSearchHeaderItem([]);
    setSearchItem([]);
  };

  const handleSignInNameClick = (row: any) => {
    setSearchProxyItem([]);
    setShowdevoteeTable(false);
    setSubmitButton(true);
    setUserFormData(userFormFields);
    setOpenProxyDialog(true);
    setProxyUser(prevValue => {
      let updatedValue = row.username;
      return updatedValue;
    })
    // setProxyUser(row.username);
    console.log(row.username, "rorrrrr");
  };

  const handleUserInNameClick = (row: any) => {
    setOpenProxyDialog(false);

    //console.log('popup row',result66)
    const updatedItems: any = searchItems.map((item: any) => {
      return {
        ...item,
        proxyUser: item.username === proxyUser ? row.username : item.proxyUser
      };
    });
    setSearchItem(updatedItems);
    console.log('searchitems', updatedItems);
    setProxyActive(true)
    setUser(row.username);
    console.log('searchitems', searchItems)
    console.log(row.username, "nameeeeeeeeeeeeeeeeeeee")
  };
  useEffect(() => {
    if (user) {
      setSearchItem((prev: any) => prev.map((item: any) => ({
        ...item,
      })));
    }
  }, [user])
  const handleProxyDialogClose = () => {
    setOpenProxyDialog(false);
  };

  const handleSuccessDialogClose = () => {
    setOpenSuccessDialog(false);
  };

  const handleConfirm = (rowData: any) => {
    ConfirmUpdateApiCall(rowData);
    // setOpenSuccessDialog(true);
  };

  const ConfirmUpdateApiCall = async (rowData: any) => {

    const _atendance = statuses?.[rowData.username] || {};
    const meetingIds = Object.keys(_atendance).filter((key: string) => _atendance[key] === 'Yes');
    setConfirmButtonLoading(true);
    setSelectedRows([]);
    setConfirmButton(true);
    // const reqBody = [{
    //   username: selectedUsernames.toString(),
    //   attendedMeetingsIds: meetingIds.map(x => parseInt(x)),
    //   proxyUsername: isScmView === true ? user : null,
    // }];

    let reqBody: any;

    if (isScmView === true) {
      reqBody = selectedUsernames.map((val: any) => {
        return {
          username: val?.username?.toString(),
          attendedMeetingsIds: meetingIds.map(x => parseInt(x)),
          proxyUsername: isScmView === true ? val?.proxyUser : null,
        }
      })
    } else {
      reqBody = [{
        username: selectedUsernames.toString(),
        attendedMeetingsIds: meetingIds.map(x => parseInt(x)),
        proxyUsername: null,
      }]
    }

    const params = isScmView === true ? { meetingId: meetingData.meetingId } : {};
    apiRequest({
      method: "POST",
      endpoint: apiPath.scmAttendedUpdateApi,
      includeToken: true,
      body: JSON.stringify(reqBody),
      params: params,
    })
      .then((res) => {
        setOpenSuccessDialog(true);
        setConfirmButton(true);
        setConfirmButtonLoading(false);
        setConfirmedUser(res.data.username);
        searchDataApi();

      })
      .catch((err) => {
        setConfirmButtonLoading(false);
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const validationSchema = object().shape({
    // username: string().required("Sign name is required"),
    // firstName: string().required("First Name is required"),
    // lastName: string().required("Last Name is required"),
    // city: string().required("City is required"),
    // state: string().required("State is required"),
    // zipcode: string().required("Zipcode is required"),
    // phonenumber: string().required("Phone Number is required"),
    // email: string()
    //   .email("Invalid email address")
    //   .required("Email is required"),
  });

  const handleSearch = async () => {
    const errors: ErrorMessageTypes = {
      username: "",
      firstName: "",
      lastName: "",
      city: "",
      state: "",
      zipcode: "",
      phonenumber: "",
      email: "",
    };
    try {
      // Validate the form data against the validation schema
      await validationSchema.validate(formData, { abortEarly: false });
      // If validation passes, you can submit the form
      setErrorMessage(errors);

      // Call your API or perform other actions here
      searchDataApi();
    } catch (error) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageTypes] = e.message;
          }
        });
      }
      setErrorMessage(errors);
    }
  };

  const searchDataApi = () => {
    setSearchItem([]);
    setSelectedRows([]);
    setConfirmButton(true);
    setShowTableComponent(false);
    const reqBody = {
      username: formData.username,
      firstname: formData.firstName,
      lastname: formData.lastName,
      city: formData.city,
      state: formData.state,
      zipcode: formData.zipcode,
      phoneNumber: formData.phonenumber,
      email: formData.email,
    };
    const requestBody = isScmView === true ? {} : reqBody;
    setLoading(true);
    apiRequest({
      method: "POST",
      endpoint: apiPath.scmSearchAttendedApi,
      body: JSON.stringify(requestBody),
      includeToken: true,
      params: {
        page: pageNumber - 1,
        size: 20,
        meetingId: isScmView === true ? meetingData.meetingId : null,
      },
    })
      .then((res) => {
        setLoading(false);
        setTotalRecords(res.data.attendances.totalElements);
        setCurrentYearStatus(res.data.currentYearStatus);
        setPreviousYearStatus(res.data.previousYearStatus);
        // setShowdevoteeTable(true);
        setShowTableComponent(true);
        setMeetingId(res.data.attendances.content.scheduledMeetingId)
        if (res.data.quarters.length === 0 && res.data.attendances.content === 0) {
          setSearchItem([]);
          setSearchHeaderItem([]);
        } else {
          setSearchHeaderItem(res.data.quarters);
          const content = res.data.attendances.content.map((item: any) => ({
            ...item,
            proxyUser: '' // You can set the initial value of proxyUser here
          }))
          // setSearchItem(res.data.attendances.content);
          setSearchItem(content);
          setErrorMessage({ ...errorMessage, username: "" });
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
      });
  };

  const meetiingSearchDataApi = () => {
    setSearchItem([]);
    setSelectedRows([]);
    setConfirmButton(true);
    const reqBody = {
      username: formData.username,
      firstname: formData.firstName,
      lastname: formData.lastName,
      city: formData.city,
      state: formData.state,
      zipcode: formData.zipcode,
      phoneNumber: formData.phonenumber,
      email: formData.email,
    };
    const requestBody = isScmView === true ? {} : reqBody;
    setLoading(true);
    apiRequest({
      method: "POST",
      endpoint: apiPath.scmSearchAttendedApi,
      body: JSON.stringify(requestBody),
      includeToken: true,
      params: {
        page: pageNumber - 1,
        size: 20,
        meetingId: isScmView === true ? meetingData.meetingId : null,
      },
    })
      .then((res) => {
        setLoading(false);
        setTotalRecords(res.data.attendances.totalElements);
        setCurrentYearStatus(res.data.currentYearStatus);
        setPreviousYearStatus(res.data.previousYearStatus);
        // setShowdevoteeTable(true);
        setShowTableComponent(true);
        setMeetingId(res.data.attendances.content.scheduledMeetingId)
        if (res.data.quarters.length === 0 && res.data.attendances.content === 0) {
          setSearchItem([]);
          setSearchHeaderItem([]);
        } else {
          setSearchHeaderItem(res.data.quarters);
          const content = res.data.attendances.content.map((item: any) => ({
            ...item,
            proxyUser: '' // You can set the initial value of proxyUser here
          }))
          // setSearchItem(res.data.attendances.content);
          setSearchItem(content);
          setErrorMessage({ ...errorMessage, username: "" });
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
      });
  };

  const searchProxyDataApi = () => {
    setSubmitLoading(true);
    const reqBody = {
      firstname: userFormData.firstName,
      lastname: userFormData.lastName,
      email: userFormData.email,
      username: userFormData.signinName,
      city: userFormData.city,
      state: userFormData.state,
      zipcode: userFormData.zipcode,
      sortBy: userFormData.signinName,
      // phoneNumber: displayPhoneNumberFormattoPlain(formData.phonenumber).length === 10 ? displayPhoneNumberFormattoPlain(formData.phonenumber) : displayPhoneNumberFormattoPlain(formData.phonenumber).substring(1),
      phoneNumber: userFormData.phonenumber,
      matchOperator: "AND"
    };
    // setLoading(true);
    apiRequest({
      method: "POST",
      endpoint: apiPath.serachDevoteeApi,
      body: JSON.stringify(reqBody),
      includeToken: true,
      params: {
        sortBy: userFormData.signinName,
        page: pageNumber - 1,
        size: 20,
        direction: "asc",
      },
    })
      .then((res) => {
        setLoading(false);
        setTotalRecords(res.data.totalElements);
        setShowdevoteeTable(true);
        setSubmitLoading(false);

        if (res.data.content.length === 0) {
          setSearchProxyItem([]);
        } else {
          setSearchProxyItem(res.data.content);
          setUserErrorMessage({ ...userErrorMessage, signinName: "" });
        }
      })
      .catch((err) => {
        setLoading(false);
        setSubmitLoading(false);
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
      });
  };

  const getSelectMeetingListApi = () => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.scmSelectMeetingApi,
      includeToken: true,
    })
      .then((res) => {
        setScmMeetingTypeList(res.data.content);
      })
      .catch((err) => {
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const zipCodeApi = () => {
    if (formData.zipcode !== "") {
      apiRequest({
        method: "GET",
        endpoint: apiPath.cityAndStateApi,
        params: {
          zip: formData.zipcode,
        },
      })
        .then((res) => {
          setErrorMessage({
            ...errorMessage,
            zipcode: "",
          });
          setFormData({
            ...formData,
            state: res.data.stateName,
            city: res.data.city,
          });
        })
        .catch((err) => {
          console.log(err);

          setErrorMessage({
            ...errorMessage,
            zipcode: catchErrorMessageHandler(err),
          });
          setFormData({
            ...formData,
            state: "",
            city: "",
          });
        });
    }
  };

  const handleCheckboxChange = (username: number) => {
    setSelectedRows([]);
    setSelectedUsernames([]);
    setConfirmButton(false);
    const selectedRow = searchItems.find(
      (row: any) => row.username === username
    );

    if (selectedRow) {
      setSelectedRows([selectedRow]);
      setSelectedUsernames([username]);
    }
  };

  // const handleCheckboxChangeForAll = (username: number) => {
  //   setSelectedRows([]);
  //   setSelectedUsernames([]);
  //   setConfirmButton(false);
  //   const selectedRow = searchItems.find(
  //     (row: any) => row.username === username
  //   );

  //   if (selectedRow) {
  //     setSelectedRows([selectedRow]);
  //     setSelectedUsernames([username]);
  //   }
  // };


  const handleCheckboxChangeForAll = (username: number, proxyUser: any) => {
    // Find the selected row based on the username
    setConfirmButton(false);
    const selectedRow = searchItems.find((row: any) => row.username === username);

    if (selectedRow) {
      // Check if the username is already selected
      if (selectedUsernames.includes(username)) {
        // If it is already selected, remove it from the selection arrays
        setSelectedRows((prevSelectedRows) =>
          prevSelectedRows.filter((row) => row.username !== username)
        );
        setSelectedUsernames((prevSelectedUsernames) =>
          prevSelectedUsernames.filter((selectedUsername) => selectedUsername !== username)
        );
      } else {
        // If it is not selected, add it to the selection arrays
        setSelectedRows((prevSelectedRows) => [...prevSelectedRows, selectedRow]);
        // setSelectedUsernames((prevSelectedUsernames) => [...prevSelectedUsernames, username]);
        setSelectedUsernames((prevSelectedUsernames) => [...prevSelectedUsernames, { username, proxyUser }]);
      }
    }

    // Enable or disable the confirm button based on the selection
    // setConfirmButton(selectedUsernames.length > 0);
  };


  const handleFieldChange = (field: string, value: any) => {
    if (formData != null) {
      setSearchButton(false);
    } else {
      setSearchButton(true);
    }
    setFormData({
      ...formData,
      [field]: value,
    });
  };

  const handleMeetingFieldChange = (field: string, value: any) => {
    setSearchButton(false);

    if (field === "meetingName") {
      // Extract and set the selected category type ID
      let category: any;
      category = scmMeetingTypeList?.filter(
        (item: any) => item.meetingName === value.meetingName
      )
      setMeetingData({
        ...meetingData,
        [field]: value,
        meetingId: category[0]?.id, // Assuming scheduledTypeId is the key for the category type ID
      });
    } else {
      setMeetingData({
        ...meetingData,
        [field]: value,
      });
    }

  };

  const handleProxyFieldChange = (field: string, value: any) => {
    if (userFormData != null) {
      setSubmitButton(false);
    } else {
      setSubmitButton(true);
    }
    setUserFormData({
      ...userFormData,
      [field]: value,
    });
  };

  const selectMeetingListDropdown = (): React.ReactElement => {
    return (
      <FormControl className={styles.donationDropdownMainContainer}>
        <CustomSelect
          defaultValue=""
          value={meetingData.meetingName}
          id="purposeOfDonations"
          IconComponent={KeyboardArrowDownIcon}
          onChange={(e) => {
            // setErrorMessage({ ...errorMessage, searchCriteria: "" });
            handleMeetingFieldChange("meetingName", e.target.value);
          }}
          className={styles.textField}
          // className={
          //   errorMessage.searchCriteria
          //     ? styles.errorTextField
          //     : styles.textField
          // }
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
        >
          {scmMeetingTypeList.map((item: any, index: number) => (
            <CustomMenuItem key={index} value={item}>
              {item.meetingName}
            </CustomMenuItem>
          ))}
        </CustomSelect>
      </FormControl>
    );
  };

  const searchFieldsContainer = () => {
    return (
      <form className={styles.SearchContainer} autoComplete="off" onSubmit={handleSearch}>
        <Box className={styles.formContainer} >
          <Card className={styles.cardContainer}>
            {isScmView === true ?
              <Grid container spacing={2}>
                <Grid xs={12} sm={6} item>
                  {CustomRequiredInputLabel("Select Meeting", true)}
                  {selectMeetingListDropdown()}
                </Grid>
              </Grid>
              :
              <div>
                <Grid container spacing={2}>
                  <Grid xs={12} sm={4} item>
                    {CustomRequiredInputLabel("Username", false)}
                    <CustomTextFeild
                      id="signInName"
                      fullWidth
                      required
                      value={formData.username}
                      onChange={(e) => {
                        handleFieldChange("username", e.target.value);
                        setErrorMessage({ ...errorMessage, username: "" });
                      }}
                      className={
                        errorMessage.username
                          ? styles.errorTextField
                          : styles.textField
                      }
                      onBlur={() => {
                        const inputUserName = formData.username.toUpperCase();
                        handleFieldChange('username', inputUserName);
                      }}
                    // onKeyDown={(e) => handleKeyDownuser(e, "username")}
                    />
                    {errorMessage.username ? (
                      <Typography sx={{ color: "red", fontSize: "12px" }}>
                        {errorMessage.username}
                      </Typography>
                    ) : (
                      ""
                    )}
                  </Grid>
                  <Grid xs={12} sm={4} item>
                    {CustomRequiredInputLabel("First Name", false)}
                    <CustomTextFeild
                      id="firstName"
                      fullWidth
                      required
                      value={formData.firstName}
                      onChange={(e) => {
                        handleFieldChange("firstName", e.target.value);
                        setErrorMessage({ ...errorMessage, firstName: "" });
                      }}
                      // onKeyDown={(e) => handleKeyDown(e, "firstName")}
                      className={
                        errorMessage.firstName
                          ? styles.errorTextField
                          : styles.textField
                      }
                    />
                    {errorMessage.firstName ? (
                      <Typography sx={{ color: "red", fontSize: "12px" }}>
                        {errorMessage.firstName}
                      </Typography>
                    ) : (
                      ""
                    )}
                  </Grid>
                  <Grid xs={12} sm={4} item>
                    {CustomRequiredInputLabel("Last Name", false)}
                    <CustomTextFeild
                      id="lastName"
                      fullWidth
                      required
                      value={formData.lastName}
                      onChange={(e) => {
                        handleFieldChange("lastName", e.target.value);
                        setErrorMessage({ ...errorMessage, lastName: "" });
                      }}
                      // onKeyDown={(e) => handleKeyDown(e, "lastName")}
                      className={
                        errorMessage.lastName
                          ? styles.errorTextField
                          : styles.textField
                      }
                    />
                    {errorMessage.lastName ? (
                      <Typography sx={{ color: "red", fontSize: "12px" }}>
                        {errorMessage.lastName}
                      </Typography>
                    ) : (
                      ""
                    )}
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ marginTop: "0px" }}>
                  <Grid xs={12} sm={4} item>
                    {CustomRequiredInputLabel("Zip Code", false)}
                    <CustomTextFeild
                      id="zipCode"
                      fullWidth
                      required
                      value={formData.zipcode}
                      onChange={(e) => {
                        const inputNumber = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
                        const slicedNumber = inputNumber.slice(0, 10); // Limit to 10 digits
                        handleFieldChange("zipcode", slicedNumber);
                        setErrorMessage({ ...errorMessage, zipcode: "" });
                      }}
                      onBlur={zipCodeApi}
                      className={
                        errorMessage.zipcode
                          ? styles.errorTextField
                          : styles.textField
                      }
                    />
                    {errorMessage.zipcode ? (
                      <Typography sx={{ color: "red", fontSize: "12px" }}>
                        {errorMessage.zipcode}
                      </Typography>
                    ) : (
                      ""
                    )}
                  </Grid>
                  <Grid xs={12} sm={4} item>
                    {CustomRequiredInputLabel("City", false)}
                    <CustomTextFeild
                      id="city"
                      fullWidth
                      required
                      onChange={(e) => {
                        handleFieldChange("city", e.target.value);
                        setErrorMessage({ ...errorMessage, city: "" });
                      }}
                      value={formData.city}
                      InputProps={{
                        readOnly: true,
                      }}
                      className={
                        errorMessage.city ? styles.errorTextField : styles.textField
                      }
                    />
                    {errorMessage.city ? (
                      <Typography sx={{ color: "red", fontSize: "12px" }}>
                        {errorMessage.city}
                      </Typography>
                    ) : (
                      ""
                    )}
                  </Grid>
                  <Grid xs={12} sm={4} item>
                    {CustomRequiredInputLabel("State", false)}
                    <CustomTextFeild
                      id="state"
                      fullWidth
                      required
                      onChange={(e) => {
                        handleFieldChange("state", e.target.value);
                        setErrorMessage({ ...errorMessage, state: "" });
                      }}
                      value={formData.state}
                      InputProps={{
                        readOnly: true,
                      }}
                      className={
                        errorMessage.state
                          ? styles.errorTextField
                          : styles.textField
                      }
                    />
                    {errorMessage.state ? (
                      <Typography sx={{ color: "red", fontSize: "12px" }}>
                        {errorMessage.state}
                      </Typography>
                    ) : (
                      ""
                    )}
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ marginTop: "0px" }}>
                  <Grid xs={12} sm={4} item>
                    {CustomRequiredInputLabel("Phone Number", false)}
                    <CustomTextFeild
                      id="phoneNumber"
                      fullWidth
                      value={formData.phonenumber}
                      onChange={(e) => {
                        const inputNumber = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
                        const slicedNumber = inputNumber.slice(0, 10); // Limit to 10 digits
                        handleFieldChange("phonenumber", slicedNumber);
                        setErrorMessage({ ...errorMessage, phonenumber: "" });
                      }}
                      className={
                        errorMessage.phonenumber
                          ? styles.errorTextField
                          : styles.textField
                      }
                    />
                    {errorMessage.phonenumber ? (
                      <Typography sx={{ color: "red", fontSize: "12px" }}>
                        {errorMessage.phonenumber}
                      </Typography>
                    ) : (
                      ""
                    )}
                  </Grid>
                  <Grid xs={12} sm={4} item>
                    {CustomRequiredInputLabel("Email ID", false)}
                    <CustomTextFeild
                      id="email"
                      fullWidth
                      required
                      value={formData.email}
                      onChange={(e) => {
                        handleFieldChange("email", e.target.value);
                        setErrorMessage({ ...errorMessage, email: "" });
                      }}
                      className={
                        errorMessage.email
                          ? styles.errorTextField
                          : styles.textField
                      }
                    />
                    {errorMessage.email ? (
                      <Typography sx={{ color: "red", fontSize: "12px" }}>
                        {errorMessage.email}
                      </Typography>
                    ) : (
                      ""
                    )}
                  </Grid>
                </Grid>
              </div>}
          </Card>
        </Box>
        <Box>
          <Grid xs={12} item>
            <CommonButton
              className={styles.search}
              onClick={handleSearch}
              disabled={searchButton || loading}
              id="search"
              type="submit"
            >
              {loading ? (
                <>
                  <ClipLoader color="#fff" loading={loading} size={15} />
                  <span
                    style={{
                      marginLeft: "8px",
                      fontSize: "15px",
                      textAlign: "center",
                    }}
                  >
                    Loading...
                  </span>
                </>
              ) : (isScmView === true ?
                "Submit" : "Search"
              )}
            </CommonButton>
          </Grid>
        </Box>
      </form>
    )
  }

  const handleDropdownChange = (value: string, username: string, itemId: any) => {

    // Assuming setStatuses and setScheduleMeetingId are React state update functions
    const updatedStatuses = { ...statuses };
    if (!updatedStatuses?.[username]) {
      updatedStatuses[username] = {};
    }
    updatedStatuses[username][`${itemId}`] = value;
    setStatuses(updatedStatuses);


    // Initialize an array to store IDs of items with "Yes" values
    const selectedIds: React.SetStateAction<any[]> = [];

    // Iterate through all items and check their values
    for (let index = 0; index < updatedStatuses.length; index++) {
      const status = updatedStatuses[index];
      if (status === "Yes") {
        selectedIds.push(index);
      } else if (status === "No" && selectedIds.includes(index)) {
        // If status is "No" but the ID was previously selected, remove it from the selectedIds array
        const indexToRemove = selectedIds.indexOf(index);
        selectedIds.splice(indexToRemove, 1);
      }
    }

    // Update the payload with the IDs of items with "Yes" values
    setScheduleMeetingId(selectedIds);
  };



  const yesNoDropdown = (
    statusText: any,
    username: string,
    itemId: any
  ): React.ReactElement => {

    return (
      <FormControl className={styles.moveToDropdown}>
        <Select
          sx={{
            background: "#fff",
            padding: "2px",
            height: "30px",
            width: "80px",
          }}
          IconComponent={KeyboardArrowDownIcon}
          value={statuses?.[username]?.[`${itemId}`] || statusText}
          onChange={(e: any) => handleDropdownChange(e.target.value, username, itemId)}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "200px",
                  "&::-webkit-scrollbar": {
                    width: "12px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#fff",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
        >
          {yesNoList.map((item: any, index: any) => (
            <CustomMenuItem key={index} value={item.status}>
              {item.status}
            </CustomMenuItem>
          ))}
        </Select>
      </FormControl>
    );
  };


  const listItemTable = () => {
    if (searchItems.length === 0) {
      return <Typography sx={{ margin: "24px auto", color: "red", fontSize: "28px" }}><b>{constants.NO_RECORDS_FOUND}</b></Typography>;
    }
    return (
      <>
        <div style={{ overflowY: "auto" }}>
          <table className={styles.tableContainer}>
            <thead>
              <tr className={styles.headerTableRow}>
                <th className={styles.tableHorizontal}></th>
                <th className={styles.tableHorizontal}>Username</th>
                <th className={styles.tableHorizontal}>Name</th>
                <th className={styles.tableHorizontal}>{previousYearStatus}</th>
                <th className={styles.tableHorizontal}>{currentYearStatus}</th>
                {searchHeaderItem.map((row: any, id: number) => (
                  <th key={id} className={styles.tableHorizontal}>{row.meetingName}</th>
                ))}
              </tr>

            </thead>
            <tbody className={styles.tableBody} id="searchScmData" >
              {searchItems.map((row: any, id: number) => (
                <tr key={id} className={styles.tableRow}>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                      cursor: "pointer",
                      textDecoration: "underline",
                    }}
                  >
                    <CustomCheckbox
                      onClick={() => setRowData(row)}
                      checked={selectedRows.some(
                        (selectedRow) =>
                          selectedRow.username === row.username
                      )}
                      onChange={() => handleCheckboxChange(row.username)}
                    />
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {row.username}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {`${row.firstname} ${row.middleName} ${row.lastname}`}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    <span style={{ color: row.previousYearStatus ? "green" : "red" }}>
                      {row.previousYearStatus}
                    </span>
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    <span style={{ color: row.currentYearStatus ? "green" : "red" }}>
                      {row.currentYearStatus ? "Active" : "Inactive"}
                    </span>
                  </td>
                  {searchHeaderItem.map((item: any, headerId: number) => {
                    const attendance = row.quartersAttendance.find(
                      (quarter: any) => quarter.scheduledMeetingId == item.scheduledMeetingId
                    );
                    return (
                      <td key={headerId} className={styles.tableDiagonal}>
                        {yesNoDropdown(attendance ? "Yes" : "No", row.username, item.scheduledMeetingId)}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {totalRecords > 20 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginRight: "10px",
              marginTop: "3px",
            }}
          >
            <Pagination
              items={totalRecords}
              itemsPerPage={20}
              setPageNumber={setPageNumber}
              pageNumber={pageNumber}
            />
          </div>
        ) : (
          ""
        )}
        <Grid sx={{ marginTop: "10px" }}>
          <CommonButton
            className={styles.search}
            onClick={() => handleConfirm(rowData)}
            disabled={confirmButton || confirmButtonLoading}
            id="search"
            type="submit"
          >
            {confirmButtonLoading ? (
              <>
                <ClipLoader color="#fff" loading={confirmButtonLoading} size={15} />
                <span
                  style={{
                    marginLeft: "8px",
                    fontSize: "15px",
                    textAlign: "center",
                  }}
                >
                  Loading...
                </span>
              </>
            ) : (
              "Confirm"
            )}
          </CommonButton>
        </Grid>
      </>
    );
  };

  const SuccessDialog = () => {
    return (
      <>
        <Dialog
          open={openSuccessDialog}
          onClose={handleSuccessDialogClose}
          aria-labelledby="cancel-dialog-title"
        >
          <div
            style={{
              backgroundColor: "#882E14",
              width: "562px",
            }}
          >
            <DialogTitle
              sx={{ fontWeight: 700, fontSize: "16px", color: "white" }}
            >
              {"SC Member Status"}
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleSuccessDialogClose}
              sx={{
                position: "absolute",
                right: 24,
                top: 8,
                color: (theme: any) => theme.palette.grey[500],
              }}
            >
              <CloseIcon sx={{ color: "white" }} />
            </IconButton>
          </div>
          <DialogContent sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <img src="/images/successImage.svg" />
            <Typography style={{ fontWeight: "400", marginBottom: "20px" }}>
              {isScmView === true ? <Typography>User's has attended the SC meeting successfully</Typography> : <Typography><b>{selectedUsernames}</b> status has attended the SC meeting</Typography>}
              {/* <b>{selectedUsernames}</b> status has attended the SC meeting */}
            </Typography>
          </DialogContent>
        </Dialog>
      </>
    )
  }

  const toggleComponent = () => {
    return (
      <>

        <Box
          sx={{
            pt: "17px",
            alignItems: "center",
          }}
        >
          <Typography sx={{ fontSize: "16px", fontWeight: 600 }}>Bulk Update</Typography>
          <Grid sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className={styles.toggle_priest_text} mr="13px">
              No
            </Typography>
            <CustomizedSwitch isChecked={isScmView} handleChange={handleToggleChange} fieldName="" />
            <Typography className={styles.toggle_priest_text} ml="13px">
              Yes
            </Typography>
          </Grid>
        </Box>
      </>
    )
  }

  const proxyListItemTable = () => {
    if (searchProxyItems.length === 0) {
      return <Typography sx={{ margin: "24px auto", color: "red", fontSize: "28px" }}><b>{constants.NO_RECORDS_FOUND}</b></Typography>;
    }
    return (
      <>
        <StyledTableContainer style={{ overflowY: "auto" }}>
          <StyledTable className={styles.tableContainer}>
            <TableHead>
              <TableRow className={styles.headerTableRow}>
                <StyledTableCell className={styles.tableHorizontal}>Sign-In Name</StyledTableCell>
                <StyledTableCell className={styles.tableHorizontal}>Name</StyledTableCell>
                <StyledTableCell className={styles.tableHorizontal}>Address</StyledTableCell>
                <StyledTableCell className={styles.tableHorizontal}>Email</StyledTableCell>
                <StyledTableCell className={styles.tableHorizontal}>PhoneNo</StyledTableCell>
                {/* <th className={styles.tableHorizontal}>Details</th> */}
              </TableRow>
            </TableHead>
            <TableBody className={styles.tableBody} id="searchData" >
              {searchProxyItems.map((row: any, id: number) => (
                <StyledTableRow key={id} className={styles.tableRow}>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                      cursor: "pointer",
                      textDecoration: "underline",
                    }}
                    onClick={() => handleUserInNameClick(row)}
                  >
                    {row.username}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {`${row.firstname} ${row.lastname}`}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {row.address}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.email}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.phoneWork}
                  </StyledTableCell>
                  {/* <td
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "center",
                    }}
                  >
                    {row.Details}
                  </td> */}
                </StyledTableRow>
              ))}
            </TableBody>
          </StyledTable>
          {totalRecords > 20 ? (
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                marginRight: "10px",
                marginTop: "3px",
              }}
            >
              <Pagination
                items={totalRecords}
                itemsPerPage={20}
                setPageNumber={setPageNumber}
                pageNumber={pageNumber}
              />
            </div>
          ) : (
            ""
          )}
        </StyledTableContainer>

      </>
    );
  };

  const DialogForProxy = () => {
    return (
      <>
        <Dialog
          open={openProxyDialog}
          onClose={handleProxyDialogClose}
          aria-labelledby="cancel-dialog-title"
        >
          <div
            style={{
              backgroundColor: "#882E14",
              width: "600px",
            }}
          >
            <DialogTitle
              sx={{ fontWeight: 700, fontSize: "16px", color: "white" }}
            >
              {"Sarch Proxy User Name"}
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleProxyDialogClose}
              sx={{
                position: "absolute",
                right: 24,
                top: 8,
                color: (theme: any) => theme.palette.grey[500],
              }}
            >
              <CloseIcon sx={{ color: "white" }} />
            </IconButton>
          </div>
          <DialogContent sx={{ display: "flex", flexDirection: "column" }}>
            {/* {proxyUsernameDropdown()} */}
            {searchDevoteeComponent()}
            <Grid sx={{ display: "flex", gap: "10px", marginTop: "10px" }}>
              {/* <CommonButton onClick={searchProxyDataApi}>Submit</CommonButton> */}
              <CommonButton
                className={styles.search}
                onClick={searchProxyDataApi}
                disabled={submitButton}
                id="submit"
                type="submit"
              >
                {submitLoading ? (
                  <>
                    <ClipLoader color="#fff" loading={submitLoading} size={15} />
                    <span
                      style={{
                        marginLeft: "8px",
                        fontSize: "15px",
                        textAlign: "center",
                      }}
                    >
                      Loading...
                    </span>
                  </>
                ) :
                  "Submit"
                }
              </CommonButton>
              <CommonOutlinedButton>Cancel</CommonOutlinedButton>
            </Grid>

            {showdevoteeTable && searchItems.length > 0 ? (
              <div style={{ marginTop: "24px" }}>{proxyListItemTable()}</div>
            ) : (
              ""
            )}

          </DialogContent>
        </Dialog>
      </>
    )
  }

  const handleSelectAll = () => {
    const allSelected = searchItems.every((row: any) =>
      selectedRows.some((selectedRow) => selectedRow.username === row.username)
    );

    if (!allSelected) {
      // If not all rows are selected, select all
      setSelectedRows([...searchItems]);
      // And update selectedUsernames with all usernames
      setSelectedUsernames(searchItems.map((row: any) => ({ username: row.username })));
    } else {
      // If all rows are selected, clear selections
      setSelectedRows([]);
      // And clear selectedUsernames
      setSelectedUsernames([]);
    }
  };

  const listItemTableForAll = () => {
    if (searchItems.length === 0) {
      return <Typography sx={{ margin: "24px auto", color: "red", fontSize: "28px" }}><b>{constants.NO_RECORDS_FOUND}</b></Typography>;
    }
    return (
      <>
        <div style={{ overflowY: "auto" }}>
          <table className={styles.tableContainer}>
            <thead>
              <tr className={styles.headerTableRow}>
                <th className={styles.tableHorizontal}>
                  <CustomCheckbox
                    checked={
                      selectedRows.length === searchItems.length
                    }
                    onChange={handleSelectAll}
                  />
                </th>
                <th className={styles.tableHorizontal}>Username</th>
                <th className={styles.tableHorizontal}>Name</th>
                <th className={styles.tableHorizontal}>{previousYearStatus}</th>
                <th className={styles.tableHorizontal}>{currentYearStatus}</th>
                {searchHeaderItem.map((row: any, id: number) => (
                  <th key={id} className={styles.tableHorizontal}>{row.meetingName}</th>
                ))}
                <th className={styles.tableHorizontal}>Username</th>
              </tr>

            </thead>
            <tbody className={styles.tableBody} id="searchScmData" >
              {searchItems.map((row: any, id: number) => (
                <tr key={id} className={styles.tableRow}>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                      cursor: "pointer",
                      textDecoration: "underline",
                    }}
                  >
                    <CustomCheckbox
                      onClick={() => setRowData(row)}
                      checked={selectedRows.some(
                        (selectedRow) =>
                          selectedRow.username === row.username
                      )}
                      onChange={() => handleCheckboxChangeForAll(row.username, row.proxyUser)}
                    />
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                      cursor: "pointer",
                      textDecoration: "underline",
                    }}
                  >
                    {row.username}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {`${row.firstname} ${row.middleName} ${row.lastname}`}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    <span style={{ color: row.previousYearStatus ? "green" : "red" }}>
                      {row.previousYearStatus ? "Active" : "Inactive"}
                    </span>
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    <span style={{ color: row.currentYearStatus ? "green" : "red" }}>
                      {row.currentYearStatus ? "Active" : "Inactive"}
                    </span>
                  </td>
                  {searchHeaderItem.map((item: any, headerId: number) => {
                    const attendance = row.quartersAttendance.find(
                      (quarter: any) => quarter.scheduledMeetingId == item.scheduledMeetingId
                    );
                    return (
                      <td key={headerId} className={styles.tableDiagonal}>
                        {yesNoDropdown(attendance ? "Yes" : "No", row.username, item.scheduledMeetingId)}
                      </td>
                    );
                  })}
                  {searchHeaderItem.map((item: any, headerId: number) => {
                    const attendance = row.quartersAttendance.find(
                      (quarter: any) => quarter.scheduledMeetingId == item.scheduledMeetingId
                    );
                    const result =
                      Object.keys(statuses)?.length
                        ? statuses[row.username][item.scheduledMeetingId] === 'Yes' ? true : false
                        : false;
                    return (
                      <td
                        key={row.proxyUser}
                        className={styles.tableDiagonal}
                        style={{
                          fontWeight: 400,
                          textAlign: "start",
                          cursor: (attendance || result) ? "pointer" : "not-allowed",
                          opacity: (attendance || result) ? 1 : 0.5,
                        }}
                        onClick={() => {
                          if (attendance || result) {
                            handleSignInNameClick(row);
                          }
                        }}
                      >
                        <div>
                          <p >{row.proxyUser}</p>
                          <p style={{ textDecoration: "underline" }}>Select User</p>
                        </div>
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {totalRecords > 20 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginRight: "10px",
              marginTop: "3px",
            }}
          >
            <Pagination
              items={totalRecords}
              itemsPerPage={20}
              setPageNumber={setPageNumber}
              pageNumber={pageNumber}
            />
          </div>
        ) : (
          ""
        )}
        <Grid sx={{ marginTop: "10px" }}>
          <CommonButton
            className={styles.search}
            onClick={() => handleConfirm(rowData)}
            disabled={confirmButton || confirmButtonLoading}
            id="search"
            type="submit"
          >
            {confirmButtonLoading ? (
              <>
                <ClipLoader color="#fff" loading={confirmButtonLoading} size={15} />
                <span
                  style={{
                    marginLeft: "8px",
                    fontSize: "15px",
                    textAlign: "center",
                  }}
                >
                  Loading...
                </span>
              </>
            ) : (
              "Confirm"
            )}
          </CommonButton>
        </Grid>
      </>
    );
  };

  const handleKeyDown = (e: any, fieldName: string) => {
    // Prevent entering numeric characters, spaces, and specific special characters
    if (
      (e.key >= "0" && e.key <= "9") ||
      e.key === " " || // prevent spaces
      /[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-=`|"\s]/.test(e.key) // prevent specific special characters and whitespace
    ) {
      e.preventDefault();
    }
  };

  const searchDevoteeComponent = () => {
    return (
      <>
        <div style={{ padding: "24px" }}>
          <Grid container spacing={2}>
            <Grid xs={12} sm={4} item>
              {CustomRequiredInputLabel("Sign-In Name", false)}
              <CustomTextFeild
                id="signInName"
                fullWidth
                required
                value={userFormData.signinName}
                onChange={(e) => {
                  handleProxyFieldChange("signinName", e.target.value);
                  setUserErrorMessage({ ...userErrorMessage, signinName: "" });
                }}
                className={
                  userErrorMessage.signinName
                    ? styles.errorTextField
                    : styles.textField
                }
                onBlur={() => {
                  const inputUserName = userFormData.signinName.toUpperCase();
                  handleProxyFieldChange('signinName', inputUserName);
                }}
              // onKeyDown={(e) => handleKeyDownuser(e, "signinName")}
              />
              {userErrorMessage.signinName ? (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  {userErrorMessage.signinName}
                </Typography>
              ) : (
                ""
              )}
            </Grid>
            <Grid xs={12} sm={4} item>
              {CustomRequiredInputLabel("First Name", false)}
              <CustomTextFeild
                id="firstName"
                fullWidth
                required
                value={userFormData.firstName}
                onChange={(e) => {
                  handleProxyFieldChange("firstName", e.target.value);
                  setUserErrorMessage({ ...userErrorMessage, firstName: "" });
                }}
                onKeyDown={(e) => handleKeyDown(e, "firstName")}
                className={
                  userErrorMessage.firstName
                    ? styles.errorTextField
                    : styles.textField
                }
              />
              {userErrorMessage.firstName ? (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  {userErrorMessage.firstName}
                </Typography>
              ) : (
                ""
              )}
            </Grid>
            <Grid xs={12} sm={4} item>
              {CustomRequiredInputLabel("Last Name", false)}
              <CustomTextFeild
                id="lastName"
                fullWidth
                required
                value={userFormData.lastName}
                onChange={(e) => {
                  handleProxyFieldChange("lastName", e.target.value);
                  setUserErrorMessage({ ...userErrorMessage, lastName: "" });
                }}
                onKeyDown={(e) => handleKeyDown(e, "lastName")}
                className={
                  userErrorMessage.lastName
                    ? styles.errorTextField
                    : styles.textField
                }
              />
              {userErrorMessage.lastName ? (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  {userErrorMessage.lastName}
                </Typography>
              ) : (
                ""
              )}
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ marginTop: "0px" }}>
            <Grid xs={12} sm={4} item>
              {CustomRequiredInputLabel("Zip Code", false)}
              <CustomTextFeild
                id="zipCode"
                fullWidth
                required
                value={userFormData.zipcode}
                onChange={(e) => {
                  handleProxyFieldChange("zipcode", e.target.value);
                  setUserErrorMessage({ ...userErrorMessage, zipcode: "" });
                }}
                onBlur={zipCodeApi}
                className={
                  userErrorMessage.zipcode
                    ? styles.errorTextField
                    : styles.textField
                }
              />
              {userErrorMessage.zipcode ? (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  {userErrorMessage.zipcode}
                </Typography>
              ) : (
                ""
              )}
            </Grid>
            <Grid xs={12} sm={4} item>
              {CustomRequiredInputLabel("City", false)}
              <CustomTextFeild
                id="city"
                fullWidth
                required
                value={userFormData.city}
                onChange={(e) => {
                  handleProxyFieldChange("city", e.target.value);
                  setUserErrorMessage({ ...userErrorMessage, city: "" });
                }}
                InputProps={{
                  readOnly: true,
                }}
                className={
                  userErrorMessage.city ? styles.errorTextField : styles.textField
                }
              />
              {userErrorMessage.city ? (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  {userErrorMessage.city}
                </Typography>
              ) : (
                ""
              )}
            </Grid>
            <Grid xs={12} sm={4} item>
              {CustomRequiredInputLabel("State", false)}
              <CustomTextFeild
                id="state"
                fullWidth
                required
                value={userFormData.state}
                onChange={(e) => {
                  handleProxyFieldChange("state", e.target.value);
                  setUserErrorMessage({ ...userErrorMessage, state: "" });
                }}
                InputProps={{
                  readOnly: true,
                }}
                className={
                  userErrorMessage.state
                    ? styles.errorTextField
                    : styles.textField
                }
              />
              {userErrorMessage.state ? (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  {userErrorMessage.state}
                </Typography>
              ) : (
                ""
              )}
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ marginTop: "0px" }}>
            <Grid xs={12} sm={4} item>
              {CustomRequiredInputLabel("Phone Number", false)}
              <CustomTextFeild
                id="phoneNumber"
                fullWidth
                value={userFormData.phonenumber}
                onChange={(e) => {
                  const inputNumber = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
                  const slicedNumber = inputNumber.slice(0, 10); // Limit to 10 digits
                  handleProxyFieldChange("phonenumber", slicedNumber);
                  setUserErrorMessage({ ...userErrorMessage, phonenumber: "" });
                }}
                className={
                  userErrorMessage.phonenumber
                    ? styles.errorTextField
                    : styles.textField
                }
              />
              {userErrorMessage.phonenumber ? (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  {userErrorMessage.phonenumber}
                </Typography>
              ) : (
                ""
              )}
            </Grid>
            <Grid xs={12} sm={4} item>
              {CustomRequiredInputLabel("Email ID", false)}
              <CustomTextFeild
                id="email"
                fullWidth
                required
                value={userFormData.email}
                onChange={(e) => {
                  handleProxyFieldChange("email", e.target.value);
                  setUserErrorMessage({ ...userErrorMessage, email: "" });
                }}
                className={
                  userErrorMessage.email
                    ? styles.errorTextField
                    : styles.textField
                }
              />
              {userErrorMessage.email ? (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  {userErrorMessage.email}
                </Typography>
              ) : (
                ""
              )}
            </Grid>
          </Grid>
        </div>
      </>
    )
  }

  return (
    <Box>
      <ToastComponent />
      {SuccessDialog()}
      {DialogForProxy()}
      <Grid>
        {searchFieldsContainer()}
        {toggleComponent()}
        {showTableComponent && !isScmView && listItemTable()}
        {showTableComponent && isScmView === true && listItemTableForAll()}
      </Grid>
    </Box>
  )
}

export default AttendedScMeetingComponent